import {
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
  ViewChild,
  ViewContainerRef,
  OnDestroy,
} from "@angular/core";
import { SubSink } from "subsink";

import { ConfigurationService, DialogService } from "@/shared-module/services";
import { ZoneComponent } from "@/shared-module/components";
import { Configuration, TableDatasource } from "@/shared-module/models";

import {
  trigger,
  state,
  style,
  transition,
  animate,
} from "@angular/animations";

@Component({
  selector: "app-table",
  templateUrl: "table.component.html",
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger("expandCollapse", [
      state(
        "open",
        style({
          height: "*",
          opacity: "1",
        }),
      ),
      state(
        "close",
        style({
          height: "0",
          opacity: "0",
        }),
      ),
      transition("open <=> close", animate(500)),
    ]),
    trigger("rotatedState", [
      state("default", style({ transform: "rotate(0)" })),
      state("rotated", style({ transform: "rotate(90deg)" })),
      transition("rotated <=> default", animate("500ms")),
    ]),
  ],
})
export class TableComponent implements OnInit, ZoneComponent, OnDestroy {
  @Input() data: TableDatasource;
  @Input() width: number;
  @Input() needpaddingLeft: boolean;
  @Input() isZoom: boolean;
  @ViewChild("template", { static: true }) template;
  cssColor: string;
  subs = new SubSink();
  openCloseAnim: string;
  state: string;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private dialogService: DialogService,
    private configurationService: ConfigurationService,
  ) {
    const thisObject = this;
    this.subs.sink = this.configurationService.config.subscribe(
      (c: Configuration) => {
        thisObject.cssColor = c.cssColor;
      },
    );
  }

  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.template);

    if (this.data.title && this.data.collapsable) {
      if (!this.openCloseAnim) {
        this.openCloseAnim = "close";
        this.state = "default";
      }
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  changeView() {
    this.openCloseAnim = this.openCloseAnim === "open" ? "close" : "open";
    this.state = this.state === "default" ? "rotated" : "default";
  }

  zoom(zoomInfo: any) {
    this.dialogService.setZoomInfo(zoomInfo);
  }
}
